import React from 'react';
import { createStyles, makeStyles} from '@material-ui/core';
import { Grid} from '@material-ui/core';
import Box from '@mui/material/Box';

export type StatusByColorProps = {
    label: string;
    text: string;
    color: any;
    backgroundColor?:  any;
};

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            margin: '10px',
        },
    })
);
const StatusByColor: React.FC<StatusByColorProps> = ({
    label,
    text,
    color,
    backgroundColor
}) => {

    const classes = useStyles();

    return (
        <Box sx={{height:"100%", marginTop:"10px"}} >
            <span 
                className="MuiFormLabel-root MuiInputLabel-root  MuiInputLabel-shrink"
                style={{marginBottom:"0px"}}>{label}</span>
                <Box sx={{
                        height:"48%", 
                        display:"flex", 
                        alignItems:"center", 
                        backgroundColor: backgroundColor?? "#efefef", 
                        borderBottom: 1.5,
                        borderColor: 'grey.500'}}>

                        <Grid alignItems="center" 
                                container spacing={1} 
                                style={{height:"fit-content", margin:0}}>

                            <Grid item style={{padding:0, margin:0}}>
                                <Box
                                    sx={{
                                        width: 20,
                                        height: 20,
                                        backgroundColor: color,
                                        padding:0,
                                        marginLeft:"10px"
                                    }}
                                />
                            </Grid>
                            <Grid alignItems="center" item style={{
                                padding:0,
                                fontSize:"0.9285714285714286rem",
                                marginLeft:"10px"
                                }}>
                                <span>{text}</span>  
                            </Grid> 
                        </Grid>      
            
                    </Box>
        </Box>
    );
};

export default React.memo(StatusByColor);